import Box from '@/Atoms/Box';
import React, {useState} from 'react';
import {View, Image, StyleSheet} from 'react-native';
import {ScreenName} from '@/navigators/StackConstants';
import CCColors from '@/Utils/CCColors';
import BannerComponent from './components/BannerComponent';
import CCHomeHeader from './components/CCHomeHeader';

const CCHomeDownloadScreen = () => {
  return (
    <Box style={styles.container}>
      <Image
        source={require('@/Assets/Images/Svgs/bottombg.svg')}
        style={styles.subcontainer}
      />
      <Image
        source={require('@/Assets/Images/Svgs/toprightbg.svg')}
        style={styles.topimage}
      />
      {/* {showAppModalHome && <SwitchToAppModal />} */}
      <Box style={styles.wrapper} flex={1}>
        <CCHomeHeader />
      </Box>
      <Box style={styles.banner}>
        <BannerComponent />
      </Box>
    </Box>
  );
};
const styles = StyleSheet.create({
  container: {
    height: '100%',
    flex: 1,
    position: 'relative',
    zIndex: 10011,
  },
  subcontainer: {
    width: 700,
    height: 300,
    position: 'absolute',
    bottom: 0,
    left: 0,
  },
  topimage: {
    width: 600,
    height: 240,
    position: 'absolute',
    top: 0,
    right: 0,
  },
  wrapper: {height: '100%'},
  banner: {
    position: 'absolute',
    zIndex: -1,
    bottom: 0,
  },
});
export default CCHomeDownloadScreen;
